 <template>
  <div class="text-center">
    <v-dialog v-model="localShow" persistent max-width="800">
      <v-card>
        <v-app-bar flat color="rgba(0, 0, 0, 0)">
          <v-spacer></v-spacer>
          <v-btn 
          class="rounded-lg pa-1"
          small
          min-width="0"
          right
          color="accentElement" elevation=0 @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
        <h2>{{ $t(type + ".deleteModal.title") }}</h2>
        <v-icon color="red" size="100" class="my-10">{{ icon ? icon : 'mdi-delete'}}</v-icon>
          <div v-html="$t(type + '.deleteModal.info')" />
          <v-row>
            <v-col>
              <v-btn color="red" @click="confirm" class="white--text my-8">
                {{ $t(type + ".deleteModal.confirmButton") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    deleteGuardNamespace: String,
    icon: String,
  },
  data() {
    return {
      localShow: false,
    };
  },
  methods: {
    cancel() {
      return this.$store.dispatch(`${this.deleteGuardNamespace}/cancel`);
    },
    confirm() {
      return this.$store.dispatch(`${this.deleteGuardNamespace}/confirm`);
    },
  },
  watch: {
    show(newValue) {
      this.localShow = newValue;
    },
    localShow(newValue) {
      if (!newValue && newValue != this.show) {
        return this.$store.dispatch(`${this.deleteGuardNamespace}/cancel`);
      }
    },
  },
  computed: {
    type() {
      if (this) {
        let type = this.$store.getters[`${this.deleteGuardNamespace}/getType`];
        if (type) {
          return type;
        }
      }
      return "genericDeleteModal";
    },
    show() {
      if (this) {
        return this.$store.getters[`${this.deleteGuardNamespace}/getShow`];
      }
      return false;
    },
  },
};
</script>

<style scoped>
h1,
p {
  line-height: 2;
}
</style>